import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IThemeState {
    // Ghi đè màu base thủ công (vd: theme switcher / test). null = không ghi đè,
    // khi đó hệ thống dùng màu của user (từ API) rồi mới tới BASE_COLOR.
    override: string | null;
}

const initialState: IThemeState = {
    override: null,
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setPrimaryColor: (state, action: PayloadAction<string>) => {
            state.override = action.payload || null;
        },
        resetPrimaryColor: (state) => {
            state.override = null;
        },
    },
});

export const { setPrimaryColor, resetPrimaryColor } = themeSlice.actions;

export default themeSlice.reducer;
